module.exports = __webpack_public_path__ + "static/media/harmonica.6f8d0929.jpg";